import React from "react";
import { FormattedMessage } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";

export default function Header() {
  return (
    <TableHeader
      title={<FormattedMessage id="document.list" defaultMessage="Dokumenty" />}
    />
  );
}
